import React from 'react';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="bg-cream section-padding" data-id="element-14">
      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-15">
        {/* Who this is for */}
        <div className="bg-white p-8 rounded-2xl shadow-soft border-t-8 border-gold" data-id="element-16">
          <h3 className="text-2xl font-bold mb-6 text-navy-dark flex items-center" data-id="element-17">
            <Check className="w-8 h-8 text-green-500 mr-3" data-id="element-18" />
            Esto ES para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-19">
            <li className="flex items-start" data-id="element-20">
              <div className="w-2 h-2 bg-gold rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-21"></div>
              <span className="text-gray-700" data-id="element-22">
                Personas de +50 años residentes en USA con activos digitales
                (Zelle, bancos online, redes sociales).
              </span>
            </li>
            <li className="flex items-start" data-id="element-23">
              <div className="w-2 h-2 bg-gold rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-24"></div>
              <span className="text-gray-700" data-id="element-25">
                Padres y abuelos que quieren evitarles dolores de cabeza y
                gastos legales a sus hijos.
              </span>
            </li>
            <li className="flex items-start" data-id="element-26">
              <div className="w-2 h-2 bg-gold rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-27"></div>
              <span className="text-gray-700" data-id="element-28">
                Dueños de cuentas de inversión o ahorros que se manejan
                principalmente por aplicaciones.
              </span>
            </li>
            <li className="flex items-start" data-id="element-29">
              <div className="w-2 h-2 bg-gold rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-30"></div>
              <span className="text-gray-700" data-id="element-31">
                Cualquier persona que valore sus fotos familiares más que
                cualquier objeto físico.
              </span>
            </li>
          </ul>
        </div>

        {/* Who this is NOT for */}
        <div className="bg-white p-8 rounded-2xl shadow-soft border-t-8 border-gray-300 opacity-80" data-id="element-32">
          <h3 className="text-2xl font-bold mb-6 text-gray-500 flex items-center" data-id="element-33">
            <X className="w-8 h-8 text-red-400 mr-3" data-id="element-34" />
            Esto NO es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-35">
            <li className="flex items-start" data-id="element-36">
              <div className="w-2 h-2 bg-gray-400 rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-37"></div>
              <span className="text-gray-600" data-id="element-38">
                Personas que no tienen familiares ni dependientes a quienes
                dejar su patrimonio.
              </span>
            </li>
            <li className="flex items-start" data-id="element-39">
              <div className="w-2 h-2 bg-gray-400 rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-40"></div>
              <span className="text-gray-600" data-id="element-41">
                Expertos en ciberseguridad que ya utilizan sistemas de herencia
                digital complejos.
              </span>
            </li>
            <li className="flex items-start" data-id="element-42">
              <div className="w-2 h-2 bg-gray-400 rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-43"></div>
              <span className="text-gray-600" data-id="element-44">
                Personas que no poseen un teléfono inteligente ni cuentas
                bancarias digitales.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}